import { useState } from "react";
import ThemeToggle from "../../views/Theme/ThemeToggle"
import LogoMksp from "../logoMksp/LogoMksp";
import SearchBar from "../searchBar/SearchBar";
import { ArrowRight } from "lucide-react";


export default function Navbar() {
  const [showPopup, setShowPopup] = useState(false);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 w-[90%] max-w-md animate-fade-in-up">
            <h2 className="text-xl dark:text-gray-200 font-semibold text-gray-800 mb-2">
              Fonctionnalité en cours
            </h2>
            <p className="text-gray-600 dark:text-gray-300">
              La section que vous souhaitez consulter est actuellement en développement afin de vous garantir une expérience optimale.
              En attendant, profitez pleinement de notre offre gratuite et découvrez les services déjà accessibles.
            </p>

            <div className="mt-6 flex justify-center content-center gap-4">

              <button
                onClick={closePopup}
                className="px-4 py-2 bg-door text-white rounded hover:bg-door-dark transition"
              >
                OK
              </button>

              <a href="/mksp/guide/university"
                className="bg-green-600 inline-flex justify-center items-center py-1 px-3 text-base font-medium text-center text-gray-100 rounded-lg border   hover:bg-green-500 focus:ring-4 focus:ring-gray-100 dark:text-white  dark:hover:bg-green-500 dark:focus:ring-gray-800 hover:bg-green-700"
              >
                Explorer les universités
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>

            </div>
          </div>
        </div>
      )}

      <nav className="fixed z-50 w-full bg-gray-50 -mt-2 dark:bg-gray-800 antialiased">
        <div className=" ">
          <div className="dark:bg-gray-900 text-white text-sm">
            <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-center py-2 px-2 gap-4">
              <div className="flex text-gray-800 dark:text-gray-400  items-center gap-4 flex-wrap">
                <span className="flex items-center gap-1">
                </span>

              </div>
              <div className="flex customStyle items-center gap-4">

                {/* <span className="hidden dark:text-gray-400 text-gray-800 md:flex items-center gap-2">
            Follow&nbsp;Us
           
            <a href="#" className="hover:text-primary">FB</a>
            <a href="#" className="hover:text-primary">IG</a>
            <a href="#" className="hover:text-primary">BE</a>
            <a href="#" className="hover:text-primary">SC</a>
          </span> */}
              </div>
            </div>
          </div>
          <header className=" dark:bg-gray-900">
            <div className="max-w-7xl mx-auto dark:bg-gray-900 flex items-center justify-between py-3 px-4 gap-4">
              {/* Logo + Search */}
              <div className="flex items-center  gap-8 flex-1 min-w-0">
                <LogoMksp />
                <button className="hidden cursor-default lg:inline-flex items-center gap-1 font-medium text-gray-700 hover:text-primary">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 fill-current" viewBox="0 0 24 24"><path d="M3 3h8v8H3zM13 3h8v8h-8zM3 13h8v8H3zM13 13h8v8h-8z" /></svg>

                </button>
                <div className="relative hidden md:block flex-1">
                  {/* <input type="text" placeholder="Search here…" className="border border-gray-300 dark:bg-gray-800 rounded-full pl-4 pr-36 py-2 w-full placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary" />
            <button className="absolute right-1 top-1/2 -translate-y-1/2 customStyle   bg-blue-800 text-white rounded-full px-6 py-1.5 text-sm font-medium">Search</button> */}

                  <SearchBar />
                </div>
              </div>
              <div className="flex items-center gap-4">


                <ThemeToggle />

                <a href="/mksp/profil" className=" customStyle  p-1 text-green-700 dark:text-green-700 flex items-center gap-1">
                  {/* User icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className=" customStyle w-4 h-4  fill-current" viewBox="0 0 24 24"><path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z" /></svg>
                </a>

                <a href="/mksp/guide" className=" sm:inline-flex text-white bgC hover:bg-primary-dark dark:text-white font-medium py-1 px-3 rounded-full whitespace-nowrap">Premium</a>
              </div>
            </div>
            <nav className=" border-gray-200   overflow-x-auto">
              <div className="max-w-7xl mx-auto flex items-center gap-3 py-2 px-4 text-xs whitespace-nowrap">
                <a href="/" className="font-medium  text-primary flex items-center gap-1">
                  <svg className="w-[17px] h-[17px] text-green-700 dark:text-green-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path  d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z"  />
                  </svg>

                  HOME
                </a>
                <a href="/mksp/guide" className="font-medium customStyle  text-gray-400 hover:text-primary flex items-center gap-1">
                  <svg className="w-[17px] h-[17px] text-green-700 dark:text-green-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16 10c0-.55228-.4477-1-1-1h-3v2h3c.5523 0 1-.4477 1-1Z" />
                    <path d="M13 15v-2h2c1.6569 0 3-1.3431 3-3 0-1.65685-1.3431-3-3-3h-2.256c.1658-.46917.256-.97405.256-1.5 0-.51464-.0864-1.0091-.2454-1.46967C12.8331 4.01052 12.9153 4 13 4h7c.5523 0 1 .44772 1 1v9c0 .5523-.4477 1-1 1h-2.5l1.9231 4.6154c.2124.5098-.0287 1.0953-.5385 1.3077-.5098.2124-1.0953-.0287-1.3077-.5385L15.75 16l-1.827 4.3846c-.1825.438-.6403.6776-1.0889.6018.1075-.3089.1659-.6408.1659-.9864v-2.6002L14 15h-1ZM6 5.5C6 4.11929 7.11929 3 8.5 3S11 4.11929 11 5.5 9.88071 8 8.5 8 6 6.88071 6 5.5Z" />
                    <path d="M15 11h-4v9c0 .5523-.4477 1-1 1-.55228 0-1-.4477-1-1v-4H8v4c0 .5523-.44772 1-1 1s-1-.4477-1-1v-6.6973l-1.16797 1.752c-.30635.4595-.92722.5837-1.38675.2773-.45952-.3063-.5837-.9272-.27735-1.3867l2.99228-4.48843c.09402-.14507.2246-.26423.37869-.34445.11427-.05949.24148-.09755.3763-.10887.03364-.00289.06747-.00408.10134-.00355H15c.5523 0 1 .44772 1 1 0 .5523-.4477 1-1 1Z" />
                  </svg>

                  TARIFS</a>
                <a href="/mksp/about" className="font-medium customStyle text-gray-400 hover:text-primary flex items-center gap-1">
                  <svg className="w-[17px] h-[17px] text-green-700 dark:text-green-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 6c0-1.65685 1.3431-3 3-3s3 1.34315 3 3-1.3431 3-3 3-3-1.34315-3-3Zm2 3.62992c-.1263-.04413-.25-.08799-.3721-.13131-1.33928-.47482-2.49256-.88372-4.77995-.8482C4.84875 8.66593 4 9.46413 4 10.5v7.2884c0 1.0878.91948 1.8747 1.92888 1.8616 1.283-.0168 2.04625.1322 2.79671.3587.29285.0883.57733.1863.90372.2987l.00249.0008c.11983.0413.24534.0845.379.1299.2989.1015.6242.2088.9892.3185V9.62992Zm2-.00374V20.7551c.5531-.1678 1.0379-.3374 1.4545-.4832.2956-.1034.5575-.1951.7846-.2653.7257-.2245 1.4655-.3734 2.7479-.3566.5019.0065.9806-.1791 1.3407-.4788.3618-.3011.6723-.781.6723-1.3828V10.5c0-.58114-.2923-1.05022-.6377-1.3503-.3441-.29904-.8047-.49168-1.2944-.49929-2.2667-.0352-3.386.36906-4.6847.83812-.1256.04539-.253.09138-.3832.13765Z" />
                  </svg>

                  ABOUT</a>
                <a href="/mksp/contact" className="font-medium  text-gray-400 customStyle hover:text-primary flex items-center gap-1">
                  <svg className="w-[17px] h-[17px] text-green-700 dark:text-green-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M7.978 4a2.553 2.553 0 0 0-1.926.877C4.233 6.7 3.699 8.751 4.153 10.814c.44 1.995 1.778 3.893 3.456 5.572 1.68 1.679 3.577 3.018 5.57 3.459 2.062.456 4.115-.073 5.94-1.885a2.556 2.556 0 0 0 .001-3.861l-1.21-1.21a2.689 2.689 0 0 0-3.802 0l-.617.618a.806.806 0 0 1-1.14 0l-1.854-1.855a.807.807 0 0 1 0-1.14l.618-.62a2.692 2.692 0 0 0 0-3.803l-1.21-1.211A2.555 2.555 0 0 0 7.978 4Z" />
                  </svg>

                  CONTACT</a>

              </div>
            </nav>
          </header>
        </div>
      </nav>

    </>
  )


}